import { useCreateOrUpdateArtworkInAuction } from "@/api/related-fields";
import { FieldConfig } from "@/config/forms/general";
import { ArtworkInAuction } from "@/lib/types";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";
import LinksDrawerLayout from "./LinksDrawerLayout";

const ArtworkInAuctionDrawer = ({
  fields,
  data,
  queryId,
  type,
}: {
  fields: FieldConfig[] | undefined;
  data: ArtworkInAuction;
  queryId: string;
  type: string;
}) => {
  const schema = z.object({
    oeuvresDansVentesDescriptionNumeroLot: z.string().optional(),
    oeuvresDansVentesDescriptionReproduitPage: z.string().optional(),
    oeuvresDansVentesDescriptionEstimationHaute: z.string().optional(),
    oeuvresDansVentesDescriptionEstimationBasse: z.string().optional(),
    oeuvresDansVentesDescriptionVendu: z.boolean().optional(),
    oeuvresDansVentesDescriptionResultatNonListe: z.boolean().optional(),
    oeuvresDansVentesDescriptionNonVenu: z.boolean().optional(),
    oeuvresDansVentesDescriptionNonVendu: z.boolean().optional(),
    oeuvresDansVentesDescriptionNonReproduit: z.boolean().optional(),
    oeuvresDansVentesDescriptionRetire: z.boolean().optional(),
    oeuvresDansVentesDescriptionMiseAPrix: z.string().optional(),
    oeuvresDansVentesDescriptionPrixMarteau: z.string().optional(),
    oeuvresDansVentesDescriptionPrixAvecFrais: z.string().optional(),
    oeuvresDansVentesDescriptionNotes: z.string().optional(),
    auction: z.object({
      ventesDescriptionNumeroVente: z.string().optional(),
      ventesDescriptionResume: z.string().optional(),
    }),
  });

  const { mutate: createOrUpdateArtworkInAuction } =
    useCreateOrUpdateArtworkInAuction(queryId, type);

  const form = useForm<z.infer<typeof schema>>({
    resolver: zodResolver(schema),
    defaultValues: {
      auction: data.auction,
      oeuvresDansVentesDescriptionNumeroLot:
        data.oeuvresDansVentesDescriptionNumeroLot,
      oeuvresDansVentesDescriptionReproduitPage:
        data.oeuvresDansVentesDescriptionReproduitPage,
      oeuvresDansVentesDescriptionEstimationHaute:
        data.oeuvresDansVentesDescriptionEstimationHaute,
      oeuvresDansVentesDescriptionEstimationBasse:
        data.oeuvresDansVentesDescriptionEstimationBasse,
      oeuvresDansVentesDescriptionVendu: data.oeuvresDansVentesDescriptionVendu,
      oeuvresDansVentesDescriptionResultatNonListe:
        data.oeuvresDansVentesDescriptionResultatNonListe,
      oeuvresDansVentesDescriptionNonVenu:
        data.oeuvresDansVentesDescriptionNonVenu,
      oeuvresDansVentesDescriptionNonVendu:
        data.oeuvresDansVentesDescriptionNonVendu,
      oeuvresDansVentesDescriptionNonReproduit:
        data.oeuvresDansVentesDescriptionNonReproduit,
      oeuvresDansVentesDescriptionRetire:
        data.oeuvresDansVentesDescriptionRetire,
      oeuvresDansVentesDescriptionMiseAPrix:
        data.oeuvresDansVentesDescriptionMiseAPrix,
      oeuvresDansVentesDescriptionPrixMarteau:
        data.oeuvresDansVentesDescriptionPrixMarteau,
      oeuvresDansVentesDescriptionPrixAvecFrais:
        data.oeuvresDansVentesDescriptionPrixAvecFrais,
      oeuvresDansVentesDescriptionNotes: data.oeuvresDansVentesDescriptionNotes,
    },
  });

  const onSubmit = (formData: z.infer<typeof schema>) => {
    createOrUpdateArtworkInAuction({
      id: data.id,
      artworkId: data.artwork.id,
      auctionId: data.auction.id,
      ...formData,
    });
  };

  return (
    <LinksDrawerLayout
      form={form}
      fields={fields ?? []}
      recordId={data.id}
      onSubmit={onSubmit}
    />
  );
};

export default ArtworkInAuctionDrawer;
